export default __webpack_public_path__ + "static/media/managepr_navicon-light.0affe463.svg";